import PartnersPage from '@/modules/admin/partners/partners-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/admin/partners')({
  component: PartnersPage,
});
